export const calculatePositionPnL = (position, currentLtp) => {
  try {
    const side = parseInt(position.side || 1);
    const netAvg = parseFloat(position.net_avg || position.avg_price || 0);
    const netQty = parseFloat(position.net_qty || position.qty || 0);

    if (!currentLtp || currentLtp <= 0 || netAvg <= 0) {
      return 0;
    }

    let pnl = 0;
    if (side === 1) {
      pnl = (currentLtp - netAvg) * netQty; // Long
    } else {
      pnl = (netAvg - currentLtp) * Math.abs(netQty); // Short
    }

    return isFinite(pnl) ? Math.round(pnl * 100) / 100 : 0;
  } catch (error) {
    console.error("P&L calculation error:", error);
    return 0;
  }
};
